import * as React from 'react';
import { IgcGridStateComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import type { IgcGridStateComponentEventMap } from 'igniteui-webcomponents-grids/grids/index.js';
import { type EventName, createComponent } from '../react-props.js';

/**
 * State component allows saving and restoring the state of the grid features.
 * @fires stateParsed - Event emitted when set state is called with a string.  Returns the parsed state object so that it can be further modified before applying to the grid.
 */
export const IgrGridState = createComponent({
  tagName: 'igc-grid-state',
  displayName: 'IgrGridState',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
  events: {
    onStateParsed: 'stateParsed' as EventName<
      IgcGridStateComponentEventMap['stateParsed']
    >,
  },
});

export type IgrGridState = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridStateModule = Component;
